import AudioManager from "../Shared/AudioManager";
import NetworkLogic from "../Shared/NetworkLogic";
import Player from "../Models/Player";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import RemoteSprite from "../Common/RemoteSprite";
import Utils from "../Shared/Utils";
import Constant from "../Shared/Constant";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class SettingLayer extends cc.Component {
    @property(cc.Prefab)
    pfbLoginLayer: cc.Prefab = null

    @property(cc.Animation)
    animation: cc.Animation = null

    @property(cc.Node)
    nodeChangePassword: cc.Node = null

    @property(cc.Node)
    nodeBasic: cc.Node = null

    @property(cc.Node)
    nodeBind: cc.Node = null

    @property(cc.Node)
    layerVolume: cc.Node = null

    @property(cc.Node)
    layerchangeMusic: cc.Node = null

    @property(cc.Node)
    layerPassword: cc.Node = null

    @property(cc.Node)
    layerPasswordTixian: cc.Node = null

    @property(cc.Node)
    layerVersion: cc.Node = null

    @property(cc.Node)
    layerbind: cc.Node = null

    @property(cc.Node)
    layerChangeServer: cc.Node = null

    @property(cc.Node)
    layerChangeLanguage: cc.Node = null

    @property(RemoteSprite)
    rspHead: RemoteSprite = null

    @property(cc.Label)
    lbUserID: cc.Label = null

    @property(cc.Label)
    lbVIP: cc.Label = null

    @property(cc.Label)
    lbVersion: cc.Label = null

    @property(cc.ProgressBar)
    barMusic: cc.ProgressBar = null

    @property(cc.ProgressBar)
    barEffect: cc.ProgressBar = null

    @property(cc.Slider)
    sliderMusic: cc.Slider = null

    @property(cc.Slider)
    sliderEffect: cc.Slider = null

    @property(cc.Toggle)
    toggleVolume: cc.Toggle = null

    @property(cc.EditBox)
    ebOldPassword: cc.EditBox = null

    @property(cc.EditBox)
    ebNewPassword: cc.EditBox = null

    @property(cc.EditBox)
    ebPasswordConfirm: cc.EditBox = null

    @property(cc.Toggle)
    togglePasswordTiXian: cc.Toggle = null

    @property(cc.EditBox)
    ebOldPasswordTiXian: cc.EditBox = null

    @property(cc.EditBox)
    ebNewPasswordTiXian: cc.EditBox = null

    @property(cc.EditBox)
    ebPasswordConfirmTiXian: cc.EditBox = null

    @property(cc.Toggle)
    toggleChangeServer: cc.Toggle = null

    private _type2Layer = {}
    private _curLayer = null;


    onLoad() {
        this._type2Layer = {
            volumeLayer: this.layerVolume,
            changeMusicLayer: this.layerchangeMusic,
            passwordLayer: this.layerPassword,
            passwordTiXianLayer: this.layerPasswordTixian,
            versionLayer: this.layerVersion,
            bindLayer: this.layerbind,
            changeServerLayer: this.layerChangeServer,
            changeLanguageLayer: this.layerChangeLanguage,
        }

        this.layerVolume.active = false
        this.layerchangeMusic.active = false
        this.layerPassword.active = false
        this.layerPasswordTixian.active = false
        this.layerVersion.active = false
        this.layerbind.active = false
        this.layerChangeServer.active = false
        this.layerChangeLanguage.active = false

        if (!Player.getPy("isSetDrawPassword")) {
            this.togglePasswordTiXian.node.active = false
        }

        // 正式环境则隐藏该标签
        if (Constant.Environment === 2) {
            this.toggleChangeServer.node.active = false
        }
    }

    start () {  
        this.showLayer("volumeLayer")
        this.init()
    }

    private init() {
        this.barMusic.progress = AudioManager.musicVolume
        this.sliderMusic.progress = AudioManager.musicVolume
        this.barEffect.progress = AudioManager.soundVolume
        this.sliderEffect.progress = AudioManager.soundVolume
        this.toggleVolume.isChecked = !AudioManager.isMusicEnabled && !AudioManager.isSoundEnabled

        if (Player.isLogedIn()) {
            this.nodeChangePassword.active = true
            this.nodeBasic.active = true
            this.lbUserID.string = Player.getPy("userID")
            this.lbVIP.string = Player.getPy("vip")
            Player.getPy("vip") > 9 && (this.lbVIP.node.parent.width = 132)
            Player.getPy("head") && (this.rspHead.url = Player.getPy("head"))
        } else {
            this.nodeChangePassword.active = false
            this.nodeBasic.active = false
            this.nodeBind.active = false;
        }
        let resVersion = cc.sys.localStorage.getItem("CurrentVersion") || '0.0.0'
        //Constant.Environment === 2 && (resVersion = resVersion.slice(0, resVersion.lastIndexOf(".")))
        this.lbVersion.string = `${i18n.t('set_text.version')}：App v${Utils.getNativeVersion()}    Res v${resVersion}`
    }

    onAnimationEnd() {
        this.node.destroy()
    }

    onBtnClick(eventTouch, userData) {
        if (userData === "close") {
            AudioManager.playSound("close")
            this.animation.play("exit_setting_layer")
        } else if (userData === "logout") {
            this.logout()
        } else if (userData === "mute") {
            this.toggleVolume.isChecked = !this.toggleVolume.isChecked
        } else if (userData === "changePassword") {
            this.changePassword()
        } else if (userData === "changePasswordTiXian") {
            this.changePasswordTiXian()
        } else if (userData === "checkUpdate") {
            this.checkUpdate()
        }
    }

    onFilter(toggle) {
        AudioManager.playSound("toggle")
        this.showLayer(toggle.node.name)
    }

    onSlider(slider, userData) {
        if (userData === "music") {
            this.barMusic.progress = slider.progress
            AudioManager.setMusicVolume(slider.progress)
        } else if (userData === "effect") {
            this.barEffect.progress = slider.progress
            AudioManager.setSoundVolume(slider.progress)
        }

        if (userData === "music" || userData === "effect") {
            this.toggleVolume.isChecked = false
        }
    }

    onToggle(toggle, userData) {
        if (userData === "mute") {
            if (toggle.isChecked) {
                AudioManager.setMusicOff()
                AudioManager.setSoundOff()
            } else {
                AudioManager.setMusicOn()
                AudioManager.setSoundOn()
            }
        }
    }

    private logout() {
        NetworkLogic.logout(function () {
            Player.logout()
            cc.instantiate(this.pfbLoginLayer).parent = this.node.parent
            this.node.destroy()
        }.bind(this))
    }

    private showLayer(name) {
        if (this._curLayer) {
            this._curLayer.active = false
        }

        this._curLayer = this._type2Layer[name]
        this._curLayer.active = true
    }

    private changePassword() {
        if (this.ebOldPassword.string.length === 0) {

            UIManager.showToastUI(i18n.t('set_text.old_paw_null'), Global.ToastType.Warnning)
            return
        } else if (this.ebOldPassword.string.length < 6 || this.ebOldPassword.string.length > 12) {
            UIManager.showToastUI(i18n.t('set_text.old_paw_limit_length'), Global.ToastType.Warnning)
            return
        }

        if (/\s/.test(this.ebNewPassword.string)){
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return false
        }
        // let pwdRegex = /[^0-9A-Za-z~！\\\\@#￥%&()*-_=+{}[]|;:''"",.<>?]+/g;
        // if (pwdRegex.test(this.ebNewPassword.string)){
        //     UIManager.showToastUI(i18n.t('set_text.new_paw_limit_length'), Global.ToastType.Warnning)
        //     cc.log("===不行");
        //     return false
        // }

        if (this.ebNewPassword.string.length === 0) {
            UIManager.showToastUI(i18n.t('set_text.new_paw_null'), Global.ToastType.Warnning)
            return
        } else if (this.ebNewPassword.string.length < 6 || this.ebNewPassword.string.length > 12){// || !(/\d+/.test(this.ebNewPassword.string) && /[a-zA-Z]+/.test(this.ebNewPassword.string))) {
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return
        }

        if (this.ebPasswordConfirm.string.length === 0) {
            UIManager.showToastUI(i18n.t('set_text.con_paw_null'), Global.ToastType.Warnning)
            return
        } else if (this.ebPasswordConfirm.string !== this.ebNewPassword.string) {
            UIManager.showToastUI(i18n.t('set_text.con_paw_consistent'), Global.ToastType.Warnning)
            return
        } else if (this.ebOldPassword.string === this.ebNewPassword.string) {
            UIManager.showToastUI(i18n.t('set_text.new_old_paw_consistent'), Global.ToastType.Warnning)
            return
        }

        UIManager.showLoadingUI()
        NetworkLogic.editPassword(this.ebOldPassword.string, this.ebNewPassword.string, function () {
            UIManager.hideLoadingUI()
            UIManager.showToastUI(i18n.t('set_text.change_succ'), Global.ToastType.OK)
            this.logout()
        }.bind(this))
    }

    private changePasswordTiXian() {
        if (!this.ebOldPasswordTiXian.string) {
            UIManager.showToastUI(i18n.t('set_text.old_paw_null'), Global.ToastType.Warnning)
            return
        } else if (this.ebOldPasswordTiXian.string.length !== 6) {
            UIManager.showToastUI(i18n.t('set_text.old_paw_limit_length'), Global.ToastType.Warnning)
            return
        } else if (!this.ebNewPasswordTiXian.string) {
            UIManager.showToastUI(i18n.t('set_text.tx_paw_null'), Global.ToastType.Warnning)
            return
        } else if (!this.ebPasswordConfirmTiXian.string) {
            UIManager.showToastUI(i18n.t('set_text.con_tx_paw'), Global.ToastType.Warnning)
            return
        } else if (this.ebNewPasswordTiXian.string !== this.ebPasswordConfirmTiXian.string) {
            UIManager.showToastUI(i18n.t('set_text.tx_paw_consistent'), Global.ToastType.Warnning)
            return
        } else if (this.ebNewPasswordTiXian.string.length !== 6) {
            UIManager.showToastUI(i18n.t('set_text.tx_paw_limit'), Global.ToastType.Warnning)
            return
        }

        UIManager.showLoadingUI()
        NetworkLogic.setDrawingPassword(this.ebOldPasswordTiXian.string, this.ebNewPasswordTiXian.string, function (data) {
            UIManager.hideLoadingUI()
            this.ebOldPasswordTiXian.string = ""
            this.ebNewPasswordTiXian.string = ""
            this.ebPasswordConfirmTiXian.string = ""
            UIManager.showToastUI(i18n.t('set_text.paw_change_succ'), Global.ToastType.OK)
        }.bind(this))
    }

    private checkUpdate() {
        if (!cc.sys.isNative) {
            return
        }

        let nativeVersion = ""
        let nums = Utils.getNativeVersion().split(".")

        // 因为服务器要求版本号为三位，所以这里特殊处理一下
        for (let i = 0; i < 3; i++) {
            const num = nums[i];
            if (num) {
                nativeVersion += (nativeVersion ? ("." + num) : num)
            } else {
                nativeVersion += (nativeVersion ? ".0" : "0")
            }
        }

        UIManager.showLoadingUI()
        let resVersion = cc.sys.localStorage.getItem("CurrentVersion") || '0.0.0';
        resVersion = resVersion.slice(0, resVersion.lastIndexOf("."));
        NetworkLogic.getHotUpdateInfo({
            devieceType: cc.sys.os,
            // packageName: Utils.getPackageName(),
            packageName: Constant.UpdatePackageName,
            // versionCode: "v" + nativeVersion
            versionCode: "v" + resVersion
        }, function (data) {
            UIManager.hideLoadingUI()
            let newNativeVersion = data && data.versionCode.replace("v", "")
            // 判断是否有新的原生版本
            if (data && nativeVersion && newNativeVersion && Utils.versionCompare(nativeVersion, newNativeVersion) < 0) {
                let isForceUpdate = parseInt(data.isForceUpdate) === 1

                if (isForceUpdate) {
                    UIManager.showTipUI(data.info.replace(",", "\n"), function () {
                        cc.sys.openURL(data.downloadUrl)
                        cc.game.end()
                    }.bind(this), i18n.t('baes_text.update'))
                } else {
                    UIManager.showConfirmUI(data.info.replace(",", "\n"), function () {
                        cc.sys.openURL(data.downloadUrl)
                    }.bind(this), i18n.t('baes_text.update'), null, i18n.t('baes_text.cancel'))
                }
            } else {

                UIManager.showToastUI(i18n.t('set_text.latest_version'), Global.ToastType.OK)
            }
        }.bind(this))
    }


}
